import { IOnFailure } from '@move-frontend/auth';
import { IResetPasswordFormData } from '../../../domain/models/IResetPasswordFormData';
import { IResetPasswordOnSuccess } from '../../../domain/models/IResetPasswordOnSuccess';
import { IResetPasswordUserData } from '../../../domain/models/IResetPasswordUserData';
import { useResetPasswordWithCallbacks } from '../../helpers/useResetPasswordWithCallbacks';

export function useResetPasswordSubmit(
	{ username, code }: IResetPasswordUserData,
	onSuccess: IResetPasswordOnSuccess,
	onFailure: IOnFailure,
) {
	const resetPassword = useResetPasswordWithCallbacks(onSuccess, onFailure);

	return ({ password }: IResetPasswordFormData) =>
		resetPassword({ username, code, newPassword: password });
}
